import { authedJson } from '../http';
import type { Position } from '../portfolioApi';

/**
 * Set ONE currency's cash balance. `balance` is the amount the account should
 * hold, not a movement: the server posts the difference as a deposit or
 * withdrawal, so a retried request cannot double-count. A negative balance is
 * margin borrowing.
 */
export interface UpdateCashRequest {
  currency: string;
  /** Target balance. Omit to change only the rate. */
  balance?: number;
  /**
   * Annual MARGIN (borrow) rate as a fraction (0.065 = 6.5% p.a.) for this
   * balance's currency. `null` clears it, omitting it leaves it untouched.
   * Reference only — nothing accrues it.
   */
  cash_interest_rate?: number | null;
  note?: string | null;
}

export function updateCashBalance(request: UpdateCashRequest): Promise<Position> {
  return authedJson<Position>('POST', '/api/v1/portfolio/cash', request);
}
